import { render } from "./ContactAdressBox.vue?vue&type=template&id=58245541&scoped=true"
import script from "./ContactAdressBox.vue?vue&type=script&lang=js"
export * from "./ContactAdressBox.vue?vue&type=script&lang=js"

import "./ContactAdressBox.vue?vue&type=style&index=0&id=58245541&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58245541"]])

export default __exports__